// src/components/tarifs/PricingPlanCard.js
import React from 'react';
import { Link } from 'react-router-dom'; // Important pour les liens internes
import './PricingPlanCard.css'; // Importe ses propres styles

function isHttpUrl(url) {
  return /^https?:\/\//i.test(String(url || '').trim());
}

function toSameOriginRelative(url) {
  const raw = String(url || '').trim();
  if (!raw) return '';
  if (!isHttpUrl(raw)) return raw;
  try {
    const u = new URL(raw);
    const origin = (typeof window !== 'undefined' && window.location && window.location.origin)
      ? window.location.origin
      : '';
    if (origin && u.origin === origin) return `${u.pathname}${u.search}${u.hash}`;
    return raw;
  } catch {
    return raw;
  }
}

function PricingPlanCard({ plan }) {
  if (!plan) {
    return null;
  }

  const rawPrice = plan.price;
  const priceStr = (typeof rawPrice === 'string') ? rawPrice : '';
  const hasTaxSuffix = priceStr.endsWith(' HT') || priceStr.endsWith(' TTC');
  const priceMain = hasTaxSuffix ? priceStr.slice(0, priceStr.lastIndexOf(' ')) : priceStr;
  const priceTax = hasTaxSuffix ? priceStr.slice(priceStr.lastIndexOf(' ') + 1) : '';

  const ctaText = String(plan.ctaText || '').trim();
  const ctaLink = String(plan.ctaLink || '').trim();
  const ctaNewTab = !!plan.ctaNewTab;
  const relLink = toSameOriginRelative(ctaLink);
  const isInternal = relLink.startsWith('/');
  const btnClass = `plan-cta-button ${plan.buttonType === 'secondary' ? 'secondary' : ''}`;

  return (
    <div className={`pricing-plan-card ${plan.isFeatured ? 'featured' : ''}`}>
      <h2 className="plan-title">{plan.title}</h2>
      <p className="plan-price">
        {hasTaxSuffix ? (
          <>
            {priceMain}
            <span className="plan-price-tax">{priceTax}</span>
          </>
        ) : (
          rawPrice
        )}
        {plan.term && <span className="term"> / {plan.term}</span>}
      </p>
      <ul className="plan-features">
        {plan.features.map((feature, index) => (
          <li key={index}>{feature}</li>
        ))}
      </ul>
      {ctaText && ctaLink ? (
        ctaNewTab ? (
          <a
            href={ctaLink}
            className={btnClass}
            target="_blank"
            rel="noopener noreferrer"
          >
            {ctaText}
          </a>
        ) : isInternal ? (
          <Link to={relLink} className={btnClass}>
            {ctaText}
          </Link>
        ) : (
          <a href={ctaLink} className={btnClass} rel="noopener noreferrer">
            {ctaText}
          </a>
        )
      ) : null}
    </div>
  );
}

export default PricingPlanCard;